module.exports = __webpack_public_path__ + "media/src/images/top_covers/1ajisai-0755b831a09ba08133c786d319de2512.png";